module.exports = __webpack_public_path__ + "static/media/5_DSC_7559-3.dceecd46.webp";